 
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import message from '@/components/message.vue';
	import {
		nextDay,
		getSearchDate
	} from "@/utils"
  import {
    orderSettlesettleFirstinfo,
    orderSettlesettleFirst,
    orderSettlesettleLastinfo,
    orderSettlesettleLast,
    orderSettlecheckSettleFirst,
    orderSettlecheckSettleLast,
    orderSettleFollowOrderAndAfterSaleCheckSettleFirst,
    orderSettleFollowOrderAndAfterSaleCheckSettleLast,
    orderSettledetailexportparamCache,


    orderSettlesettleInfo,
    orderSettlecheckSettle,
    orderSettleFollowOrderAndAfterSaleCheckSettle,
    orderSettlecheckSettleReject,
    orderSettlesettleTime
  } from "@/api/order"
	import {
		handleClipboard
	} from '@/utils/clipboard'
  import {  getUserInfo } from '@/utils/storage';
  import axios from 'axios';
	import UploadImg from '@/components/upload-img.vue';
	import Switch from '@/components/switch.vue';
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-message': message,
      UploadImg,
			'slz-switch': Switch,
    }
  })

  export default class ProductList extends Vue {
    private pageloading = false
    private firstBill = false
    private form:any = {
      FirstSettleProductInfoList:[]
    }
		private defaultThumb = 'https://cdn2024.routuan.com/routuanapp/default-thumb.png';
    private messageShow = false
    private messageloading = false
    private type = 1
    private disabled = Number(this.$route.query.FinanceOrderSettleRecordId)>0
    private confirmShow = false
    private listName = ''
    private CheckType = 0

    private rejectShow = false
    private rejectReason = ''
    private popoverShow = false
    private batchNum = ''

    private mounted () {
      this.firstBill = (this.$route.query.firstBill=='true')
      this.listName = (this.$route.query.firstBill=='true')?'First':'Last'
      this.getinfo()
    }



    private get userInfo() {
      return getUserInfo()
    }



    private confirmBatchChange(){
      let num = Number(this.batchNum)
      if(num<1||num>100){
        this.$message.error('请输入1-100的数值')
        return
      }
      this.popoverShow = false
      this.form.FirstSettleInfo.FirstSettleProductInfoList = this.form.FirstSettleInfo.FirstSettleProductInfoList.map(v=>{
        v.FirstFinanceOrderSettleRate = num
        return v
      })
      this.blurSettle({},0,'',true)
    }
    private simplifytime(time){
      if(time){
        return time.substring(0,10)
      }else{
        return ''
      }
    }
    private async toreject(){
      try{
        if(!this.rejectReason){
          this.$message.error('请输入驳回原因')
          return 
        }
        let res = await orderSettlecheckSettleReject({
          FinanceOrderSettleRecordId:this.$route.query.FinanceOrderSettleRecordId,
          RejectReason:this.rejectReason
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.$router.go(-1)
        }
      }finally{
        //
      }
    }
    private uploadSuc(e,key){
      // console.log(e)
      this.form[key] = e.map(v=>{
        return {
          Name:v.name,
          Url:v.url
        }
      })
      // console.log(e)
    }
    private toODdetail(row,type,time){
      this.$router.push({
        path:'orderDetails',
        query:{
          FinanceOrderSettleOrderDetailFromPageType:type,
          FinanceOrderSettleRecordId:this.form.FinanceOrderSettleRecordId,
          // StartTime:this.$route.query.StartTime,
          // EndTime:this.$route.query.EndTime,
          ProductId:row.ProductId,
          SpecValue:row.SpecValue,
          ProviderId:this.form.ProviderId,
          StartTime:time.StartTime,
          EndTime:nextDay(time.EndTime,1)
        }
      })
    }
    private toAFdetail(row,time){
      this.$router.push({
        path:'aftersaleDetails',
        query:{
          FinanceOrderSettleRecordId:this.form.FinanceOrderSettleRecordId,
          ProviderId:this.form.ProviderId,
          StartTime:time.StartTime,
          EndTime:nextDay(time.EndTime,1)
        }
      })
    }
    private tabSpan({ row, column, rowIndex, columnIndex }){
      if(this.form.ProviderContractType==1){
        if(columnIndex==3){
          return [this.form.accountlist.length-1,1]
        }
        if(row.type==6){
          if(columnIndex==1){
            return [1,3]
          }else if(columnIndex==4){
            return [1,1]
          }else{
            return [0,0]
          }
        }
      }else{
        if(columnIndex==3){
          return [this.form.accountlist.length,1]
        }else{
          return [1,1]
        }
      }
      
    }
    private exportServiceCharge(){
      let url = location.origin
      url += '/pc/finance/orderSettle/serviceFee/detail/export'
      url += '?FinanceOrderSettleRecordId=' + this.form.FinanceOrderSettleRecordId
      window.open(url)
    }
    private exportfile(){
      let url = location.origin
      url += '/pc/finance/orderSettle/detail/export'
      url += '?FinanceOrderSettleRecordId=' + this.form.FinanceOrderSettleRecordId
      window.open(url)
    }
    private blurother(key){
      let two = /^\d+(\.\d{1,2})?$/
      if(String(this.form[key])!=''&&(this.form[key]<0||this.form[key]>99999999.99||!two.test(this.form[key]))){
        this.$message.error('请输入0~99999999.99的数值，最多2位小数')
        this.form[key] = 0
        return
      }
      this.blurSettle()
    }
    private changeImpactCalculation(key){
      if(this.form[key]<=0||this.form[key]==''){
        return
      }
      this.blurSettle()
    }
    private torules(row){
      this.$router.push({
        name:'settleFreight',
        query:{
          Id:row.ProductId,
          Name:encodeURIComponent(row.ProductName),
					Img:encodeURIComponent(row.ImgUrlComplete || this.defaultThumb),
        }
      })
    }
    private copy(e){
      let text = `开户人：${this.form.CardHolder}\n`
      text += `开户银行：${this.form.BankName}\n`
      text += `开户行：${this.form.SubbranchName}\n`
      text += `账号：${this.form.BankCardNumber}\n`
      handleClipboard(text,e)
    }
    private async toSettle(type){
      if(!this.form.PreLastSettleInfo&&!this.form.PreFirstSettleInfo&&!this.form.FirstSettleInfo&&!this.form.SupportSettleInfo){
        this.$message.error('操作失败，无待结算数据')
        return
      }
      if(this.CheckType){
        this.documentaryCheck(type)
        return
      }
      this.type = type
      try{
        this.type = 2
        this.messageShow = true
        this.messageloading = false
        let form = JSON.parse(JSON.stringify(this.form))
        if(!form.FirstSettleInfo.FirstSettleProductInfoList||!form.FirstSettleInfo.FirstSettleProductInfoList.length){
          form.FirstSettleInfo.FirstSettleProductInfoList = []
        }
        let res = await orderSettlecheckSettle({
          SettleInfo:{
            ...form,
            FirstSettleInfo:{
              ...form.FirstSettleInfo,
              FirstSettleProductInfoList:form.FirstSettleInfo?.FirstSettleProductInfoList.map(v=>{
                v.FirstFinanceOrderSettleRate = Number((v.FirstFinanceOrderSettleRate*100).toFixed(0))/10000
                return v
              })
            }
          },
          ...this.$route.query
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.messageShow = false
        }
      }catch{
        setTimeout(()=>{
          this.messageShow = false
        },2000)
      }finally{
        this.confirmShow = false
      }
    }
    private async documentaryCheck(type){
      this.type = type
      try{
        this.messageShow = true
        this.messageloading = false
        this.confirmShow = false
        let form = JSON.parse(JSON.stringify(this.form))
        
        if(!form.FirstSettleInfo.FirstSettleProductInfoList||!form.FirstSettleInfo.FirstSettleProductInfoList.length){
          form.FirstSettleInfo.FirstSettleProductInfoList = []
        }
        let res:any = await orderSettleFollowOrderAndAfterSaleCheckSettle({
          FinanceOrderSettleRecordId:form.FinanceOrderSettleRecordId,
          SettleInfo:{
            ...form,
            FirstSettleInfo:{
              ...form.FirstSettleInfo,
              FirstSettleProductInfoList:form.FirstSettleInfo.FirstSettleProductInfoList.map(v=>{
                v.FirstFinanceOrderSettleRate = Number((v.FirstFinanceOrderSettleRate*100).toFixed(0))/10000
                return v
              })
            },
          },
          ...this.$route.query,
          CheckType:this.CheckType,
        })
        if(res.IsSuccess){
          this.messageloading = true
          // this.getinfo()
          if(type==2){
            this.$message.success('结算数据已提交，该提示需要手动关闭弹窗')
            return
          }
        }

      }finally{
        if(type==2){
          return
        }
        setTimeout(()=>{
          this.messageShow = false
        },2000)
      }
    }
    private async blurSettle(row?:any,num?:any,key?:string,notTest?:boolean){
      this.type = 1
      //1.8.3批量修改的时候跳过这个验证
      if(key&&!notTest){
        if(key=='FirstFinanceOrderSettleRate'){
          if(num<1||num>100||num!=parseInt(num)){
            this.$message.error('请输入1-100的数值')
            return
          }
        }else{
          let two = /^\d+(\.\d{1,2})?$/
          if(!num){
            this.$message.error('请输入补贴金额')
            return
          }
          if(num<0||num>99999999.99||!two.test(num)){
            this.$message.error('请输入正确的补贴金额')
            return
          }
        }
      }
      try{
        this.messageShow = true
        this.messageloading = false
        let res:any
        let form = JSON.parse(JSON.stringify(this.form))
        if(!form.FirstSettleInfo.FirstSettleProductInfoList||!form.FirstSettleInfo.FirstSettleProductInfoList.length){
          form.FirstSettleInfo.FirstSettleProductInfoList = []
        }
        let data:any = {
          ...form,
          FirstSettleInfo:{
            ...form.FirstSettleInfo,
            FirstSettleProductInfoList:form.FirstSettleInfo?.FirstSettleProductInfoList.map(v=>{
              v.FirstFinanceOrderSettleRate = Number((v.FirstFinanceOrderSettleRate*100).toFixed(0))/10000
              return v
            })
          }
        }
        res = await orderSettlesettleInfo({
          FinanceOrderSettleRecordId:this.$route.query.FinanceOrderSettleRecordId,
          SettleInfo:data,
          ...this.$route.query
        })
        if(res.IsSuccess){
          let form2 = res.Result
          form2.SpecialReduceAttachmentInfoList = form.SpecialReduceAttachmentInfoList
          form2.SpecialAddAttachmentInfoList = form.SpecialAddAttachmentInfoList
          form2.RoutuanReduceSellMoneyAttachmentInfoList = form.RoutuanReduceSellMoneyAttachmentInfoList
          // console.log(form,form.SpecialReduceAttachmentInfoList,form.SpecialAddAttachmentInfoList)

          form2.FinanceOrderSettleRecordId = this.$route.query.FinanceOrderSettleRecordId
          if(form2.FirstSettleInfo&&form2.FirstSettleInfo.FirstSettleProductInfoList&&form2.FirstSettleInfo.FirstSettleProductInfoList.length){
            form2.FirstSettleInfo.FirstSettleProductInfoList = form2.FirstSettleInfo.FirstSettleProductInfoList.map(v=>{
              v.FirstFinanceOrderSettleRate = Number((v.FirstFinanceOrderSettleRate*10000).toFixed())/100
              return v
            })
          }
          let restime = await orderSettlesettleTime({})
          if(!form2.PreLastSettleInfo){
            form2.PreLastSettleInfo = {
              SubmitOrderStartDate:restime.Result.PreSettleStartDate,
              SubmitOrderEndDate:restime.Result.PreSettleEndDate,
              ActualSettleAllMoney:0,
            }
          }
          if(!form2.PreFirstSettleInfo){
            form2.PreFirstSettleInfo = {
              SubmitOrderStartDate:restime.Result.PreSettleStartDate,
              SubmitOrderEndDate:restime.Result.PreSettleEndDate,
              ActualSettleAllMoney:0,
            }
          }
          if(!form2.FirstSettleInfo){
            form2.FirstSettleInfo = {
              SubmitOrderStartDate:restime.Result.PreSettleStartDate||'',
              SubmitOrderEndDate:restime.Result.PreSettleEndDate||'',
              ActualSettleAllMoney:0,
            }
          }
          form2.accountlist = this.getaccountlist(form2)
          this.form = form2
        }
      }finally{
        setTimeout(()=>{
          this.messageShow = false
        },2000)
      }
    }
    private async getinfo(){
      try{
        this.pageloading = true
        let res = await orderSettlesettleInfo({...this.$route.query})
        if(res.IsSuccess){
          let form = res.Result
          form.FinanceOrderSettleRecordId = this.$route.query.FinanceOrderSettleRecordId,
          form.FirstSettleInfo.FirstSettleProductInfoList = form.FirstSettleInfo?.FirstSettleProductInfoList.map(v=>{
            v.FirstFinanceOrderSettleRate = Number((v.FirstFinanceOrderSettleRate*10000).toFixed())/100
            return v
          })
          
          let restime = await orderSettlesettleTime({})
          if(!form.PreLastSettleInfo){
            form.PreLastSettleInfo = {
              SubmitOrderStartDate:restime.Result.PreSettleStartDate,
              SubmitOrderEndDate:restime.Result.PreSettleEndDate,
              ActualSettleAllMoney:0,
            }
          }
          if(!form.PreFirstSettleInfo){
            form.PreFirstSettleInfo = {
              SubmitOrderStartDate:restime.Result.PreSettleStartDate,
              SubmitOrderEndDate:restime.Result.PreSettleEndDate,
              ActualSettleAllMoney:0,
            }
          }
          if(!form.FirstSettleInfo){
            form.FirstSettleInfo = {
              SubmitOrderStartDate:restime.Result.PreSettleStartDate||'',
              SubmitOrderEndDate:restime.Result.PreSettleEndDate||'',
              ActualSettleAllMoney:0,
            }
          }
          form.accountlist = this.getaccountlist(form)
          this.form = form
        }
      }finally{
        this.pageloading = false
      }
    }
    private change(){
      this.$router.push({
        path:'account',
        query:{
          CardHolder:this.form.CardHolder,
          BankCode:this.form.BankCode,
          BankCardNumber:this.form.BankCardNumber,
          ProviderId:this.$route.query.ProviderId,
          FinanceOrderSettleRecordId:this.$route.query.FinanceOrderSettleRecordId,
        }
      })
    }
    private getaccountlist(form){
      let accountlist = []
      accountlist = [
        form.PreFinanceOrderSettleRecordId?{
          name:`上次对账单（${this.simplifytime(form.PreLastSettleInfo.SubmitOrderStartDate)}至${this.simplifytime(form.PreLastSettleInfo.SubmitOrderEndDate)}）的尾款`,
          money:form.PreLastSettleInfo.ActualSettleAllMoney,
          type:1,
        }:undefined,
        form.PreFinanceOrderSettleRecordId?{
          name:`上次对账单（${this.simplifytime(form.PreFirstSettleInfo.SubmitOrderStartDate)}至${this.simplifytime(form.PreFirstSettleInfo.SubmitOrderEndDate)}）剩余新签收的订单全款`,
          money:form.PreFirstSettleInfo.ActualSettleAllMoney,
          type:2,
        }:undefined,
        form.PreFinanceOrderSettleRecordId?{
          name:'本次结算日期下的所有订单首款/全款 (期间有开团产品为首款，则为全款)',
          money:form.FirstSettleInfo.ActualSettleAllMoney,
          type:3,
        }:{
          name:`${this.simplifytime(form.SubmitOrderStartDate)}至${this.simplifytime(form.SubmitOrderEndDate)}已签收的订单首款`,
          money:form.FirstSettleInfo.ActualSettleAllMoney,
          type:3,
        },
        {
          name:'期间完结的售后',
          money:form.SupportSettleInfo?.SupportSettleProductInfoList?.reduce((acc,val)=>{
            let allacc = acc
            allacc+=val.RefundProductMoney
            allacc+=val.SupportSubsidyMoney
            allacc+=val.SupportReturnFreightInsuranceMoney
            return +(allacc).toFixed(2)
          },0)||0,
          type:4,
        },
        form.ProviderContractType==1?{
          name:'服务费税额',
          money:form.TaxFee,
          tip:`（说明：服务费${form.ServiceFee}）`,
          type:5,
          ServiceFee:form.ServiceFee
        }:undefined,
        form.ProviderContractType==1?{
          name:`平台服务费=商家销售额(含运费)${form.RoutuanSellIncome}-售后支出${form.SupportRealRefundAllMoney}-结算金额${form.CalculateServiceFeeOrderSettleMoney}=${form.ServiceFee}`,
          type:6,
        }:undefined
      ].filter(v=>v).map(v=>{
        if(v.type==4){
          v.money = (v.money==0?'':'-')+v.money
        }
        return v
      })
      return accountlist
    }
  }
